import React from 'react'
import Slider from 'react-slick';

const Featurestwo = () => {
    const Featureslider1 = {
        speed: 8000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }
    const Featureslider2 = {
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 6,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }
    return (
        <div className="features-two">
            <div className="container-fluid p-0">
                <Slider className="features-slider-two" {...Featureslider1}>
                    <div className="features-two-slider-item">
                        <h2>Dispersión y recaudo de pagos</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>|</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>Pagos transfronterizos</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>|</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>Tesorería en la nube — próximamente</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>|</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>Colombia · Estados Unidos · China</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>|</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>Infraestructura de pagos para empresas</h2>
                    </div>
                    <div className="features-two-slider-item">
                        <h2>|</h2>
                    </div>
                </Slider>
                <Slider className="features-slider-three" {...Featureslider2}>

                    <div className="features-three-slider-item">
                        <h3>Dispersión y recaudo de pagos</h3>
                    </div>
                    <div className="features-three-slider-item">
                        <h3>Pagos transfronterizos</h3>
                    </div>
                    <div className="features-three-slider-item">
                        <h3>Tesorería en la nube — próximamente</h3>
                    </div>
                    <div className="features-three-slider-item">
                        <h3>Colombia · Estados Unidos · China</h3>
                    </div>
                    <div className="features-three-slider-item">
                        <h3>Infraestructura de pagos para empresas</h3>
                    </div>
                </Slider>
            </div>
        </div >

    )
}
export default Featurestwo;